/**
 * Returns true if the current user has the Empresa.All App Role.
 *
 * Shares the same ['auth-me'] query as useAllowedEmpresas — no extra API call.
 * Only users with Empresa.All should see the Empresa and Almacén filters.
 */
import { useQuery } from '@tanstack/react-query'
import { authApi } from '@/services/api'

export function useIsEmpresaAll(): boolean {
  const { data } = useQuery({
    queryKey: ['auth-me'],
    queryFn: authApi.getMe,
    staleTime: 60 * 60 * 1000,  // 1 h — roles don't change mid-session
    gcTime:    60 * 60 * 1000,
    retry: false,
  })
  return data?.isEmpresaAll ?? false
}